import React, { useEffect, useState, useRef, useCallback } from 'react';
import './About.css'
export default function About() {
    // ===== DÉCLARATIONS POUR LE SLIDER =====
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const [direction, setDirection] = useState('left');
    const intervalRef = useRef(null);

    const teamMembers = [
        { name: 'Babacar', title: 'Cofondateur & CTO', icon: '👨‍💻', bio: 'Ingénieur Logiciel avec 5+ ans en management IT' },
        { name: 'Marie', title: 'Cofondatrice & CEO', icon: '👩‍💻', bio: 'Ingénieur Logiciel' },
        { name: 'Néné', title: 'Lead Développeuse', icon: '👩‍💻', bio: 'Ingénieur Logiciel avec 5+ ans en management IT' },
        { name: 'Faty', title: 'Lead Développeuse', icon: '👩‍💻', bio: 'Ingénieur Logiciel avec 5+ ans en management IT' },
        { name: 'Hamid', title: 'Lead Designer', icon: '🎨', bio: 'Graphiste Professionnel avec 5+ d\'expérience' }
    ];

    const totalSlides = teamMembers.length;
    const visibleCount = 3;

    const getVisibleCards = () => {
        const cards = [];
        for (let i = 0; i < visibleCount; i++) {
            const index = (currentIndex + i) % totalSlides;
            cards.push({ ...teamMembers[index], displayIndex: i });
        }
        return cards;
    };

    // Utiliser useCallback pour mémoriser les fonctions
    const nextSlide = useCallback(() => {
        if (isAnimating) return;
        setIsAnimating(true);
        setDirection('left');
        setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, [isAnimating, totalSlides]);

    const prevSlide = useCallback(() => {
        if (isAnimating) return;
        setIsAnimating(true);
        setDirection('right');
        setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
    }, [isAnimating, totalSlides]);

    // Ajouter nextSlide comme dépendance
    useEffect(() => {
        intervalRef.current = setInterval(nextSlide, 4000);
        return () => clearInterval(intervalRef.current);
    }, [nextSlide]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, 600);
        return () => clearTimeout(timer);
    }, [currentIndex]);

    const visibleCards = getVisibleCards();
    // ===== FIN DÉCLARATIONS POUR LE SLIDER =====

    return (
        <div className="about-page">
            <div className="container" style={{ paddingTop: '120px', minHeight: '100vh', paddingBottom: '4rem' }}>
                <div className="section-header">
                    <h1 style={{ fontSize: '3rem', marginBottom: '2rem' }}>À Propos d'ApplicodeTech</h1>
                    <p style={{ fontSize: '1.2rem', color: '#9ca3af', maxWidth: '600px', margin: '0 auto' }}>
                        Votre partenaire de confiance pour la transformation digitale
                    </p>
                </div>

                {/* Section Intro */}
                <div style={{ maxWidth: '900px', margin: '4rem auto', lineHeight: '1.8', color: '#d1d5db', textAlign:'justify' }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', color: '#fff' }}>Qui sommes-nous ?</h2>
                    <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                        ApplicodeTech est une startup technologique basée à Saint-Louis, Sénégal,
                        fondée en 2022. Nous accompagnons les entreprises, les organisations et les
                        entrepreneurs dans leur transformation numérique en proposant des solutions
                        innovantes, performantes et adaptées aux réalités du contexte technologique actuel.
                    </p>

                    <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                        Nous intervenons aussi bien à distance qu'en présentiel,
                        afin d'offrir un accompagnement flexible répondant aux
                        besoins de nos clients, où qu'ils se trouvent.
                    </p>
                    <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                        Nos domaines d'expertise couvrent le développement
                        d'applications web et mobiles, l'intelligence artificielle (IA),
                        les solutions cloud, le design UI/UX, ainsi que d'autres services
                        numériques permettant aux entreprises de moderniser leurs processus
                        et de développer des produits adaptés aux exigences du marché.
                    </p>
                    <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                        Notre objectif est d'aider les entreprises à accélérer
                        leur digitalisation, à optimiser leurs opérations et à
                        concevoir des produits et services alignés sur les évolutions
                        technologiques actuelles.
                    </p>
                    <p style={{ marginBottom: '2rem', fontSize: '1.1rem' }}>
                        Notre équipe est composée d'ingénieurs logiciels,
                        de designers UI/UX et de consultants IT passionnés.
                        Nous travaillons en étroite collaboration avec chacun
                        de nos clients afin de comprendre leurs besoins,
                        de proposer des solutions sur mesure et de garantir
                        des résultats de haute qualité, durables et créateurs de valeur.
                    </p>
                </div>

                {/* Section Mission Vision Valeurs */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: '2rem',
                    margin: '3rem auto',
                    maxWidth: '1000px'
                }}>
                    <div style={{
                        background: 'rgba(255, 126, 95, 0.05)',
                        border: '1px solid rgba(255, 126, 95, 0.2)',
                        padding: '2rem',
                        borderRadius: '10px'
                    }}>
                        <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#ff7e5f' }}>🎯 Notre Mission</h3>
                        <p style={{ color: '#9ca3af', lineHeight: '1.6' }}>
                            Transformer les défis technologiques en opportunités de croissance en fournissant des solutions IT innovantes,
                            accessibles et adaptées aux besoins des entreprises africaines.
                        </p>
                    </div>

                    <div style={{
                        background: 'rgba(97, 218, 251, 0.05)',
                        border: '1px solid rgba(97, 218, 251, 0.2)',
                        padding: '2rem',
                        borderRadius: '10px'
                    }}>
                        <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#61DAFB' }}>🚀 Notre Vision</h3>
                        <p style={{ color: '#9ca3af', lineHeight: '1.6' }}>
                            Devenir le leader régional des solutions technologiques en Afrique de l'Ouest, reconnu pour notre excellence,
                            notre innovation et notre engagement envers la réussite de nos clients.
                        </p>
                    </div>

                    <div style={{
                        background: 'rgba(255, 126, 95, 0.05)',
                        border: '1px solid rgba(255, 126, 95, 0.2)',
                        padding: '2rem',
                        borderRadius: '10px'
                    }}>
                        <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#ff7e5f' }}>💎 Nos Valeurs</h3>
                        <ul style={{ listStyle: 'none', paddingLeft: 0, color: '#9ca3af' }}>
                            <li style={{ marginBottom: '0.75rem' }}>✓ <strong>Innovation</strong> - Exploration constante</li>
                            <li style={{ marginBottom: '0.75rem' }}>✓ <strong>Qualité</strong> - Excellence sans compromis</li>
                            <li style={{ marginBottom: '0.75rem' }}>✓ <strong>Intégrité</strong> - Honnêteté et transparence</li>
                            <li>✓ <strong>Collaboration</strong> - Succès partagé</li>
                        </ul>
                    </div>
                </div>

                {/* Section Stats */}
                <div style={{ margin: '4rem auto', maxWidth: '900px' }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '2rem', color: '#fff', textAlign: 'center' }}>Nos Réalisations</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '2rem' }}>
                        <div style={{ textAlign: 'center', padding: '1.5rem', background: 'rgba(255, 126, 95, 0.1)', borderRadius: '8px' }}>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#ff7e5f' }}>5+</div>
                            <div style={{ color: '#9ca3af', marginTop: '0.5rem' }}>Projets Réalisés</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '1.5rem', background: 'rgba(97, 218, 251, 0.1)', borderRadius: '8px' }}>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#61DAFB' }}>10+</div>
                            <div style={{ color: '#9ca3af', marginTop: '0.5rem' }}>Clients Satisfaits</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '1.5rem', background: 'rgba(255, 126, 95, 0.1)', borderRadius: '8px' }}>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#ff7e5f' }}>4+</div>
                            <div style={{ color: '#9ca3af', marginTop: '0.5rem' }}>Années d'Expérience</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '1.5rem', background: 'rgba(97, 218, 251, 0.1)', borderRadius: '8px' }}>
                            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#61DAFB' }}>5+</div>
                            <div style={{ color: '#9ca3af', marginTop: '0.5rem' }}>Membres d'Équipe</div>
                        </div>
                    </div>
                </div>

                {/* Section Équipe - Version Animée */}
                <div style={{ margin: '4rem auto', maxWidth: '1200px' }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '2rem', color: '#fff', textAlign: 'center' }}>
                        L'Équipe de Direction
                    </h2>
                    <p style={{ color: '#9ca3af', textAlign: 'center', marginBottom: '3rem', fontSize: '1.1rem' }}>
                        Des leaders passionnés au service de l'innovation
                    </p>

                    <div className="direction-slider-wrapper">
                        <div className="direction-slider-container">
                            <button
                                className="direction-nav prev"
                                onClick={prevSlide}
                                aria-label="Précédent"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>

                            <div className="direction-slider-track">
                                <div
                                    className={`direction-slider ${isAnimating ? `slide-${direction}` : ''}`}
                                >
                                    {visibleCards.map((member) => (
                                        <div
                                            key={`${member.name}-${member.displayIndex}`}
                                            className="direction-card"
                                        >
                                            <div className="direction-card-inner">
                                                <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>{member.icon}</div>
                                                <h3 style={{ color: '#fff', marginBottom: '0.5rem', fontSize: '1.25rem' }}>
                                                    {member.name}
                                                </h3>
                                                <p style={{ color: '#ff7e5f', fontWeight: '600', marginBottom: '0.75rem', fontSize: '0.9rem' }}>
                                                    {member.title}
                                                </p>
                                                <p style={{ color: '#9ca3af', fontSize: '0.9rem', lineHeight: '1.5' }}>
                                                    {member.bio}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <button
                                className="direction-nav next"
                                onClick={nextSlide}
                                aria-label="Suivant"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        <div className="direction-indicators">
                            {teamMembers.map((_, index) => (
                                <button
                                    key={index}
                                    className={`direction-indicator ${index === currentIndex ? 'active' : ''}`}
                                    onClick={() => {
                                        if (index > currentIndex) setDirection('left');
                                        else if (index < currentIndex) setDirection('right');
                                        setCurrentIndex(index);
                                    }}
                                    aria-label={`Voir ${teamMembers[index].name}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Section Pourquoi nous */}
                <div style={{
                    margin: '4rem auto',
                    maxWidth: '900px',
                    padding: '3rem',
                    background: 'rgba(255, 126, 95, 0.05)',
                    border: '1px solid rgba(255, 126, 95, 0.2)',
                    borderRadius: '10px'
                }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '2rem', color: '#ff7e5f' }}>Pourquoi Choisir ApplicodeTech ?</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', color: '#d1d5db' }}>
                        <div>
                            <h4 style={{ color: '#fff', marginBottom: '0.5rem' }}>✓ Expertise Locale</h4>
                            <p>Nous comprenons le contexte africain et les défis spécifiques des entreprises locales.</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#fff', marginBottom: '0.5rem' }}>✓ Technologies Modernes</h4>
                            <p>Stack technologique à jour : React, Node.js, Cloud, AI, Machine Learning.</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#fff', marginBottom: '0.5rem' }}>✓ Communication Transparente</h4>
                            <p>Rapports réguliers, démonstrations et feedback constant avec nos clients.</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#fff', marginBottom: '0.5rem' }}>✓ Support Long Terme</h4>
                            <p>Maintenance, mises à jour et support continu après le lancement.</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#fff', marginBottom: '0.5rem' }}>✓ Tarifs Compétitifs</h4>
                            <p>Excellent rapport qualité/prix sans frais cachés. Nous nous adaptons à votre budget.</p>
                        </div>
                        <div>
                            <h4 style={{ color: '#fff', marginBottom: '0.5rem' }}>✓ Méthodologie Agile</h4>
                            <p>Sprints courts, livrables réguliers et adaptation aux changements de besoins.</p>
                        </div>
                    </div>
                </div>

                {/* Section Clients Secteurs */}
                <div style={{ margin: '4rem auto', maxWidth: '900px' }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '2rem', color: '#fff', textAlign: 'center' }}>Secteurs Servis</h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                        gap: '1rem'
                    }}>
                        {[
                            'Éducation', 'Santé', 'Finance', 'Retail', 'Agriculture', 'Logistique',
                            'Energie', 'Tourisme', 'Immobilier', 'Télécommunications', 'Gouvernement', 'Startup'
                        ].map((secteur, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: '1rem',
                                    background: 'rgba(255, 126, 95, 0.1)',
                                    border: '1px solid rgba(255, 126, 95, 0.2)',
                                    borderRadius: '6px',
                                    textAlign: 'center',
                                    color: '#ff7e5f',
                                    fontWeight: '500'
                                }}
                            >
                                {secteur}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Section Technologies */}
                <div style={{ margin: '4rem auto', maxWidth: '900px' }}>
                    <h2 style={{ fontSize: '1.8rem', marginBottom: '2rem', color: '#fff', textAlign: 'center' }}>Technologies Maîtrisées</h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                        gap: '1rem'
                    }}>
                        {[
                            'React.js', 'Vue.js', 'Node.js', 'Python', 'Java', 'Spring Boot',
                            'MongoDB', 'PostgreSQL', 'AWS', 'Google Cloud', 'Docker', 'Kubernetes',
                            'React Native', 'Flutter', 'TypeScript', 'GraphQL', 'REST API', 'Git'
                        ].map((tech, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: '1rem',
                                    background: 'rgba(97, 218, 251, 0.1)',
                                    border: '1px solid rgba(97, 218, 251, 0.2)',
                                    borderRadius: '6px',
                                    textAlign: 'center',
                                    color: '#61DAFB',
                                    fontWeight: '500'
                                }}
                            >
                                {tech}
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTA Final */}
                <div style={{
                    margin: '4rem auto 0',
                    maxWidth: '800px',
                    padding: '3rem',
                    background: 'linear-gradient(135deg, rgba(255, 126, 95, 0.1) 0%, rgba(97, 218, 251, 0.1) 100%)',
                    border: '1px solid rgba(255, 126, 95, 0.2)',
                    borderRadius: '10px',
                    textAlign: 'center'
                }}>
                    <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#fff' }}>Prêt à travailler ensemble ?</h2>
                    <p style={{ color: '#9ca3af', marginBottom: '2rem', fontSize: '1.1rem' }}>
                        Contactez-nous dès aujourd'hui pour discuter de votre projet et découvrir comment ApplicodeTech peut vous aider à réussir.
                    </p>
                    <a
                        href="/contact"
                        style={{
                            background: '#ff7e5f',
                            color: '#fff',
                            padding: '0.875rem 1.75rem',
                            borderRadius: '6px',
                            textDecoration: 'none',
                            fontWeight: '600',
                            display: 'inline-block',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#ff6a48';
                            e.target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = '#ff7e5f';
                            e.target.style.transform = 'translateY(0)';
                        }}
                    >
                        Contactez-nous
                    </a>
                </div>
            </div>
        </div>
    );
}